/**
 * The editor's YAML view: the document itself, as plain text (a textarea,
 * so nothing in it is ever read as markup). Comments and layout typed here
 * are kept, until a change in the form rewrites the text.
 */

import type { ReactElement } from 'react';

interface YamlViewProps {
  value: string;
  onChange: (text: string) => void;
  /** While the editor switches to the form: typing would be lost, so it is refused visibly. */
  readOnly?: boolean;
}

export function YamlView({ value, onChange, readOnly = false }: YamlViewProps): ReactElement {
  return (
    <textarea
      className="def-editor__yaml"
      aria-label="YAML"
      value={value}
      readOnly={readOnly}
      aria-busy={readOnly}
      rows={Math.min(Math.max(value.split('\n').length + 1, 10), 30)}
      spellCheck={false}
      autoCapitalize="off"
      autoCorrect="off"
      autoComplete="off"
      onChange={(e) => { onChange(e.target.value); }}
    />
  );
}
